import React from "react";
import { Box, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import css from "./search.module.scss";

interface SearchProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const Search: React.FC<SearchProps> = ({
  placeholder = "Search",
  value,
  onChange,
}) => {
  return (
    <Box className={css.searchBox}>
      <SearchIcon className={css.searchIcon} />
      <InputBase
        className={css.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  );
};

export default Search;
